import { CheckoutState } from './CheckoutState';
import { Map } from 'immutable';
import { checkoutActionType } from 'src/constants/checkoutActionType';
/**
 *  Image gallery reducer
 */
var storArr = [];
export var checkoutReducer = function (state, action) {
    if (state === void 0) { state = Map(new CheckoutState()); }
    var payload = action.payload;
    var post = payload;
    switch (action.type) {
        case checkoutActionType.ADD_TO_CART:
            var updatePostOwnerId = post.get('ownerUserId');
            var updatePostId = post.get('id');
            storArr.push(post);
            console.log('STORE', storArr);
            // localStorage.arr = JSON.stringify(storArr)
            // localStorage.bag = JSON.stringify(post)
            // var storedState: string = localStorage.getItem('bag')!
            // var storedStateP =  JSON.parse(storedState)
            return state
                .setIn(['PostArr', updatePostOwnerId, updatePostId], Map(payload));
        // TODO : sort array by id and binarysearch remove post
        case checkoutActionType.REMOVE_FROM_CART:
            // localStorage.bag = JSON.stringify(post)
            // var storedState: string = localStorage.getItem('arr')!
            // var storedStateP: Array<Map<string,any>> =  JSON.parse(storedState)
            var ownerId = post.get('ownerUserId');
            var postId = post.get('id');
            // for (var i = 0; i < storedStateP.length; i++) {
            //   var arrpost = Map(storedStateP[i])
            //   if (arrpost.get('id') === payload.get('id')) {
            //     storedStateP.splice(i, 1)
            //   }
            // }
            // localStorage.arr = JSON.stringify(storedStateP)
            return state
                .removeIn(['PostArr', ownerId, postId]);
        default:
            return state;
    }
};
var updatePost = function (state, payload) {
    var post = payload.post;
    var updatePostOwnerId = post.get('ownerUserId');
    var updatePostId = post.get('id');
    return state
        .setIn(['userPosts', updatePostOwnerId, updatePostId], Map(post));
};



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/Checkout/CheckoutReducer.ts
// module id = 585
// module chunks = 50